var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMedia = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    enableBackground: "new 0 0 60 60",
    viewBox: "0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31,16H17v14h14V16z M29,28H19V18h10V28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m52 16h-16c-0.553 0-1 0.447-1 1s0.447 1 1 1h16c0.553 0 1-0.447 1-1s-0.447-1-1-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m52 22h-16c-0.553 0-1 0.447-1 1s0.447 1 1 1h16c0.553 0 1-0.447 1-1s-0.447-1-1-1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m52 28h-16c-0.553 0-1 0.447-1 1s0.447 1 1 1h16c0.553 0 1-0.447 1-1s-0.447-1-1-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m52 34h-33c-0.553 0-1 0.447-1 1s0.447 1 1 1h33c0.553 0 1-0.447 1-1s-0.447-1-1-1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m34 40h-15c-0.553 0-1 0.447-1 1s0.447 1 1 1h15c0.553 0 1-0.447 1-1s-0.447-1-1-1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m34 46h-15c-0.553 0-1 0.447-1 1s0.447 1 1 1h15c0.553 0 1-0.447 1-1s-0.447-1-1-1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m34 52h-15c-0.553 0-1 0.447-1 1s0.447 1 1 1h15c0.553 0 1-0.447 1-1s-0.447-1-1-1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39,54h14V40H39V54z M41,42h10v10H41V42z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M59,13c0-0.017-0.009-0.031-0.01-0.048V0H11v30H1v24c0,3.309,2.691,6,6,6h46c3.303,0,5.99-2.688,5.99-5.99V13.048   C58.991,13.031,59,13.017,59,13z M56.99,2v10H13V2H56.99z M3,54V32h8v22c0,2.206-1.794,4-4,4S3,56.206,3,54z M53,58H11.469   c0.016-0.018,0.027-0.039,0.042-0.057c0.204-0.233,0.39-0.482,0.556-0.745c0.027-0.042,0.052-0.084,0.078-0.128   c0.162-0.27,0.305-0.552,0.423-0.848c0.016-0.041,0.03-0.082,0.045-0.123c0.115-0.306,0.209-0.622,0.273-0.949   c0.006-0.03,0.008-0.061,0.014-0.09C12.962,54.716,13,54.362,13,54V30V14h43.99v40.01C56.99,56.21,55.2,58,53,58z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M47,4H23v6h24V4z M45,8H25V6h20V8z"
  })));
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMedia, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/media.7a110b2e.svg";
export { ForwardRef as ReactComponent };